import { PairApi } from '@voladeum/client';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import { v4 as uuidv4 } from 'uuid';

import { Pair } from './types';

export const normalizePairs = (data: PairApi[]): Pair[] => data.map((d) => normalizePair(d));

export const normalizePair = (row: PairApi): Pair => {
  return {
    ...row,
    price_formatted: formatValue(row.price, { format: FORMAT_TYPE.CURRENCY }),
    price_change_formatted: formatValue(row.price_change, { format: FORMAT_TYPE.CURRENCY }),
    price_change_pct_formatted: formatValue(row.price_change_pct, {
      format: FORMAT_TYPE.PERCENT_ABBREVIATED,
      decimal: 2,
    }),
    market_cap_formatted: formatValue(row.market_cap, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    market_cap_change_formatted: formatValue(row.market_cap_change, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    market_cap_rank_formatted: formatValue(row.market_cap_rank, { format: FORMAT_TYPE.NUMBER }),
    high_formatted: formatValue(row.high, { format: FORMAT_TYPE.CURRENCY }),
    low_formatted: formatValue(row.low, { format: FORMAT_TYPE.CURRENCY }),
    volume_formatted: formatValue(row.volume, { format: FORMAT_TYPE.NUMBER }),
    total_supply_formatted: formatValue(row.total_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    max_supply_formatted: formatValue(row.max_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    circulating_supply_formatted: formatValue(row.circulating_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    uuid: uuidv4(),
  };
};
